import { render, staticRenderFns } from "./CheckpointTypeBanner.vue?vue&type=template&id=ef762268&scoped=true"
import script from "./CheckpointTypeBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointTypeBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointTypeBanner.vue?vue&type=style&index=0&id=ef762268&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef762268",
  null
  
)

export default component.exports